import { Record } from 'immutable';

export const mkBrowser = Record({
  name: 'unknown',
  version: 'unknown',
});

export const mkDevice = Record({
  type: 'unknown',
  vendor: 'unknown',
  model: 'unknown',
});

export const mkPlatform = Record({
  browser: mkBrowser(),
  device: mkDevice(),
  os: undefined,

  displayMode: 'standalone',
  isPwaInstalled: false,

  supportsOnBeforeInstallPrompt: false,
  supportsManualAddToHomeScreen: false,

  supportsPushNotifications: false,

  isMouseSupported: true,
  isChromebook: new Promise((resolve) => {
    resolve(false);
  }),
});
